export const atlasColors = {
  bgPrimary: "#07111f",
  bgViewer: "radial-gradient(circle at top, #0b1a2a, #07111f)",
  bgViewerPremium:
    "radial-gradient(circle at top left, rgba(34,211,238,0.08), transparent 32%), linear-gradient(180deg, #07111f 0%, #050b16 100%)",
  bgCardPremium:
    "linear-gradient(180deg, rgba(15,23,42,0.94) 0%, rgba(2,6,23,0.92) 100%)",
  bgCard: "rgba(2,6,23,0.72)",
  border: "rgba(34,211,238,0.14)",
  borderHover: "rgba(34,211,238,0.30)",
  borderMuted: "rgba(148,163,184,0.18)",
  borderActive: "rgba(34,211,238,0.28)",
  accent: "#22d3ee",
  textPrimary: "#e2e8f0",
  textSecondary: "#94a3b8",
} as const;

export const atlasTheme = {
  root: `background:${atlasColors.bgPrimary}`,
  viewer: `background:${atlasColors.bgViewerPremium}`,
  card: `background:${atlasColors.bgCardPremium};border:1px solid ${atlasColors.borderMuted};box-shadow:0 18px 45px rgba(0,0,0,0.28),inset 0 1px 0 rgba(255,255,255,0.06)`,
  cardActive: `background:${atlasColors.bgCardPremium};border:1px solid ${atlasColors.borderActive};box-shadow:0 20px 60px rgba(0,0,0,0.35),0 0 0 1px rgba(34,211,238,0.08),inset 0 1px 0 rgba(255,255,255,0.07)`,
};

export default atlasColors;
